import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// Angular Material
import { MatIconModule }     from '@angular/material/icon';
import { MatButtonModule }   from '@angular/material/button';
import { MatTooltipModule }  from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ContractWorkflowListComponent }   from './contract-workflow-list.component';
import { ContractWorkflowDetailComponent } from './contract-workflow-detail.component';
import { ContractWorkflowService }         from './contract-workflow.service';
import  {ContractWorkflowPageComponent} from './contract-workflow-page.component';
// Shared SafeUrl pipe (add to SharedModule if not already there)
//import { SafeUrlPipe } from '../../../pipes/safe.pipe';
//import { SafePipe } from '../../../pipes/safe.pipe';
const routes: Routes = [
  // /workflow/contract-task/:taskId  — full-screen task detail page
  { path: 'contract-task/:taskId', component: ContractWorkflowDetailComponent }
];

@NgModule({
  declarations: [
    ContractWorkflowListComponent,
    ContractWorkflowDetailComponent,
    ContractWorkflowPageComponent  
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forChild(routes),
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    ContractWorkflowListComponent,
    ContractWorkflowDetailComponent,
    ContractWorkflowPageComponent
  ],
  providers: [ContractWorkflowService]
})
export class ContractWorkflowModule {}
